// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/montserrat-regular-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/montserrat-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/montserrat-regular-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/montserrat-regular-webfont.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#montserratregular" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */
@font-face {
  font-family: 'Montserrat';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  @font-face {
    font-family: 'Montserrat';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('svg');
  }
  select {
    font-family: Arial, Helvetica, sans-serif;
  }
}
/* Base */
html {
  overflow-y: scroll;
}
body {
  background: #f3f3f3;
  font-family: "Montserrat";
  color: #333333 !important;
}
.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.row > div {
  margin-bottom: 8px;
}
.alerts-container .alert:last-child {
  margin-bottom: 0;
}
#page-wrapper {
  padding-left: 70px;
  height: 100%;
}
#sidebar-wrapper {
  margin-left: -190px;
  left: -30px;
  width: 290px;
  position: fixed;
  height: 100%;
  z-index: 999;
}
#page-wrapper,
#sidebar-wrapper {
  transition: all 0.4s ease 0s;
}
.green {
  background: #23ae89 !important;
}
.blue {
  background: #2361ae !important;
}
.orange {
  background: #d3a938 !important;
}
.red {
  background: #ae2323 !important;
}
.form-group .help-block.form-group-inline-message {
  padding-top: 5px;
}
div.input-mask {
  padding-top: 7px;
}
.nowrap {
  white-space: nowrap;
}
.ml-1 {
  margin-left: 1em;
}
.ml-2 {
  margin-left: 2em;
}
.form-horizontal .schema-form-text {
  padding-left: 15px;
  padding-right: 15px;
}
.form-horizontal .schema-form-text .form-control-feedback {
  margin-right: 15px;
}
.form-horizontal .schema-form-textarea {
  padding-left: 15px;
  padding-right: 15px;
}
.form-horizontal .schema-form-textarea textarea.form-control {
  height: 34px;
  padding-right: 0;
}
/*
bootstrap hack: fix content width inside hidden tabs
https://stackoverflow.com/a/23267110/853876
*/
.tab-content > .tab-pane:not(.active),
.pill-content > .pill-pane:not(.active) {
  display: block;
  height: 0;
  overflow-y: hidden;
}
/* bootstrap hack end */
`, "",{"version":3,"sources":["webpack://./layout/resources/less/main.less"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,yBAAA;EACA,4CAAA;EACA,mPAAA;EAIA,mBAAA;EACA,kBAAA;AAFF;AAIA;EACI;IACE,yBAAA;IACA,0DAAA;EAFJ;EAIE;IACE,yCAAA;EAFJ;AACF;AACA,SAAS;AAKT;EACI,kBAAA;AAHJ;AAKA;EACI,mBAAA;EACA,yBAAA;EACA,yBAAA;AAHJ;AAKA;EACI,yBAAA;EACA,0BAAA;AAHJ;AAKA;EACI,kBAAA;AAHJ;AAKA;EACI,gBAAA;AAHJ;AAKA;EACI,kBAAA;EACA,YAAA;AAHJ;AAKA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AAHJ;AAKA;;EACI,4BAAA;AAFJ;AAIA;EACI,8BAAA;AAFJ;AAIA;EACI,8BAAA;AAFJ;AAIA;EACI,8BAAA;AAFJ;AAIA;EACI,8BAAA;AAFJ;AAIA;EACI,gBAAA;AAFJ;AAIA;EACI,gBAAA;AAFJ;AAIA;EACI,mBAAA;AAFJ;AAIA;EACI,gBAAA;AAFJ;AAIA;EACI,gBAAA;AAFJ;AAKA;EACI,kBAAA;EACA,mBAAA;AAHJ;AACA;EAKS,kBAAA;AAHT;AAMA;EACI,kBAAA;EACA,mBAAA;AAJJ;AAEA;EAKQ,YAAA;EACA,gBAAA;AAJR;AACA;;;CAGC;AAQD;;EAEI,cAAA;EACA,SAAA;EACA,kBAAA;AANJ;AACA,uBAAuB","sourcesContent":["/* Fonts */\n@font-face {\n  font-family: 'Montserrat';\n  src: url('../fonts/montserrat-regular-webfont.eot');\n  src: url('../fonts/montserrat-regular-webfont.eot?#iefix') format('embedded-opentype'),\n       url('../fonts/montserrat-regular-webfont.woff') format('woff'),\n       url('../fonts/montserrat-regular-webfont.ttf') format('truetype'),\n       url('../fonts/montserrat-regular-webfont.svg#montserratregular') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n    @font-face {\n      font-family: 'Montserrat';\n      src: url('../fonts/montserrat-regular-webfont.svg') format('svg');\n    }\n    select {\n      font-family: Arial, Helvetica, sans-serif;\n    }\n}\n\n/* Base */\nhtml {\n    overflow-y: scroll;\n}\nbody {\n    background: #f3f3f3;\n    font-family: \"Montserrat\";\n    color: #333333 !important;\n}\n.row {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n}\n.row > div {\n    margin-bottom: 8px;\n}\n.alerts-container .alert:last-child {\n    margin-bottom: 0;\n}\n#page-wrapper {\n    padding-left: 70px;\n    height: 100%\n}\n#sidebar-wrapper {\n    margin-left: -190px;\n    left: -30px;\n    width: 290px;\n    position: fixed;\n    height: 100%;\n    z-index: 999;\n}\n#page-wrapper, #sidebar-wrapper {\n    transition: all .4s ease 0s;\n}\n.green {\n    background: #23ae89 !important;\n}\n.blue {\n    background: #2361ae !important;\n}\n.orange {\n    background: #d3a938 !important;\n}\n.red {\n    background: #ae2323 !important;\n}\n.form-group .help-block.form-group-inline-message {\n    padding-top: 5px;\n}\ndiv.input-mask {\n    padding-top: 7px;\n}\n.nowrap {\n    white-space: nowrap;\n}\n.ml-1 {\n    margin-left: 1em;\n}\n.ml-2 {\n    margin-left: 2em;\n}\n\n.form-horizontal .schema-form-text {\n    padding-left: 15px;\n    padding-right: 15px;\n\n    .form-control-feedback {\n         margin-right: 15px;\n    }\n}\n.form-horizontal .schema-form-textarea {\n    padding-left: 15px;\n    padding-right: 15px;\n\n    textarea.form-control {\n        height: 34px;\n        padding-right: 0;\n    }\n}\n\n/*\nbootstrap hack: fix content width inside hidden tabs\nhttps://stackoverflow.com/a/23267110/853876\n*/\n.tab-content > .tab-pane:not(.active),\n.pill-content > .pill-pane:not(.active) {\n    display: block;\n    height: 0;\n    overflow-y: hidden;\n}\n/* bootstrap hack end */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
